export default __webpack_public_path__ + "static/media/292.0dc1a6b5.jpg";